import { Controller } from "@hotwired/stimulus";

// Connects with data-controller="flash"
export default class extends Controller {
  close() {
    this.element.remove();
  }
}
